import { render, staticRenderFns } from "./PublicacionesReportes.vue?vue&type=template&id=ec6b594a&"
import script from "./PublicacionesReportes.vue?vue&type=script&lang=js&"
export * from "./PublicacionesReportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports